import React, { useMemo } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { ClientesMAinScreen } from "../Clientes/ClientesMAinScreen";
import { FiscalMainScren } from "../Fiscal/FiscalMainScren";
import { RRHHMainScreen } from "../RRHH/RRHHMainScreen";
import { CreditoyCobranzaMainScreen } from "../CreditoyCobranza/CreditoyCobranzaMainScreen";
import { FinanzasMainScreen } from "../Finanzas/FinanzasMainScreen";
import { DashboardInicial } from "./DashboardInicial";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { AnalisisCreditoScreen } from "../AnalisisCredito/AnalisisCreditoScreen";
import { ListadoCredito } from "../Credito/ListadoCredito";
import { ConfiguracionesMainScreen } from "../PermisosUsuarios/ConfiguracionesMainScreen";
import { VentasMain } from "../Ventas/VentasMain";
import { AdministracionMainScreen } from "../Administracion/AdministracionMainScreen";
import { RegistroClienteMainScreen } from "../RegistroClientesVendedores/RegistroClienteMainScreen";
import { UsadosListado } from "../Usados/UsadosListado";
import {
  ProductoAliadoListado,
} from "../ProductoAliado/ProductoAliadoListado";
import { RutasPostventaScreen } from "../Postventa/RutasPostventaScreen";
import { SimuladorIncentivosScreen } from "../SimuladorIncentivos/SimuladorIncentivosScreen";
import { MensajeriaListadoScreen } from "../Mensajeria/MensajeriaListadoScreen";
import { RutasAuditoria } from "../Auditoria/RutasAuditoria";
import { CentroMonitoreoMainScreen } from "../CentroMonitoreo/CentroMonitoreoMainScreen";
import { GestionTIMainScreen } from "../GestionTI/GestionTIMainScreen";
import { PlaneacionEstrategicaMain } from "../PlaneacionEstrategica/PlaneacionEstrategicaMain";
import CarteraTransitoMainScreen from "../CarteraTransito/CarteraTransitoMainScreen";
import { CRMMainScreen } from "../CRM/CRMMainScreen";

export const ContentScreen = () => {
  const routerContent = useMemo(() => {
    return (
      <Router>
        <Switch>
          <Route path={`/Home/Dashboard`} component={DashboardInicial} />
          <Route path="/Clientes/Main" component={ClientesMAinScreen} />
          <Route path="/DashClientes/" component={CRMMainScreen} />
          <Route path="/Fiscal/" component={FiscalMainScren} />
          <Route path="/Administracion/" component={AdministracionMainScreen} />
          <Route path="/RRHH/Main" component={RRHHMainScreen} />
          <Route path="/CreditoyCobranza/" component={CreditoyCobranzaMainScreen} />
          <Route path="/Finanzas" component={FinanzasMainScreen} />
          <Route path="/SolicitudCredito" component={AnalisisCreditoScreen} />
          <Route path="/Credito" component={ListadoCredito} />
          <Route path="/Permisos" component={ConfiguracionesMainScreen} />
          <Route path="/Ventas" component={VentasMain} />
          <Route path="/VClientes/Main" component={RegistroClienteMainScreen} />
          <Route path="/Usados" component={UsadosListado} />
          <Route path="/ProductoAliado" component={ProductoAliadoListado} />
          <Route path="/Postventa" component={RutasPostventaScreen} />
          <Route path="/SI" component={SimuladorIncentivosScreen} />
          <Route path="/Home/Mensajeria" component={MensajeriaListadoScreen} />
          <Route path="/Mensajeria" component={MensajeriaListadoScreen} />
          <Route path="/Auditoria" component={RutasAuditoria} />
          <Route path="/CentroMonitoreo" component={CentroMonitoreoMainScreen} />
          <Route path="/GestionTI" component={GestionTIMainScreen} />
          <Route path="/PlaneacionEstrategica" component={PlaneacionEstrategicaMain} />
          <Route path="/CarteraTransito" component={CarteraTransitoMainScreen} />
          <Redirect to={`/Home/Dashboard`} />
        </Switch>
      </Router>
    );
  }, []); // 🔥 IMPORTANTE: array vacío

  return (
    <div id="hd-content-screen">
      {routerContent}
    </div>
  );
};
